import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NumberFormatModule } from '@prlw/libs/number-format/number-format.module';
import { OverflowFaderDirective } from '@prlw/libs/overflow-fader/overflow-fader.directive';
import { ResponsiveDirective } from '@prlw/libs/responsive/responsive.directive';
import { ResponsiveService } from '@prlw/libs/responsive/responsive.service';

@Component({
  selector: 'prlw-market-depth-ui',
  standalone: true,
  imports: [
    CommonModule,
    NumberFormatModule,
    ResponsiveDirective,
    OverflowFaderDirective,
  ],
  templateUrl: './market-depth.component.html',
  styleUrl: './market-depth.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketDepthComponent {
  @Input() bid: [number, number][] | null = null;
  @Input() ask: [number, number][] | null = null;

  constructor(private readonly responsiveService: ResponsiveService) {}

  xsmall$ = this.responsiveService.xsmall$;

  get askWithSorting() {
    return this.xsmall$.getValue()
      ? (this.ask?.slice().sort(([a], [b]) => b - a) ?? [])
      : this.ask;
  }

  getFillStyle(
    value: number,
    color: string,
    direction: 'left' | 'right' = 'left',
  ) {
    const max = [...(this.bid ?? []), ...(this.ask ?? [])].reduce(
      (acc, [, amount]) => (acc > amount ? acc : amount),
      0,
    );
    if (max === 0) return 'none';
    const fill = Math.floor((value / max) * 100);
    return `background: linear-gradient(to ${direction}, ${color} ${fill}%, white ${fill}%)`;
  }

  getAskDirection() {
    return this.xsmall$.getValue() ? 'left' : 'right';
  }
}
